import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from "react";

export enum PurchaseStatus {
  NOT_STARTED = "NOT_STARTED",
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

interface PurchaseStatusContent {
  purchaseStatus: PurchaseStatus;
  setPurchaseStatus: (status: PurchaseStatus) => void;
}

const PurchaseStatusContext = createContext<PurchaseStatusContent>({
  purchaseStatus: PurchaseStatus.NOT_STARTED,
  setPurchaseStatus: () => {},
});

export const PurchaseStatusProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [purchaseStatus, setPurchaseStatus] = useState<PurchaseStatus>(
    PurchaseStatus.NOT_STARTED
  );

  const value = { purchaseStatus, setPurchaseStatus };

  return (
    <PurchaseStatusContext.Provider value={value}>
      {children}
    </PurchaseStatusContext.Provider>
  );
};

export const usePurchaseStatusProvider = () =>
  useContext(PurchaseStatusContext);
